import { Tooltip } from 'antd'

import { Flexbox } from './Flexbox'

import { useLocale } from '@/context/localeContext'
import { createCommaSeparatedString, pluralise } from '@/utils/index'

type Subcontractor = {
  company: {
    name: string
  }
}

type Props = {
  subcontractors: Subcontractor[]
}

export const SubcontractorDisplay: React.FC<Props> = ({ subcontractors }) => {
  const { t } = useLocale()

  if (!subcontractors.length) return null

  if (subcontractors.length === 1) {
    return <>{subcontractors[0].company.name}</>
  }

  return (
    <Tooltip
      title={createCommaSeparatedString(
        subcontractors.map((s) => s.company.name),
        true
      )}
    >
      <Flexbox flex="inline-flex" alignItems="center" gap="0.25rem">
        {pluralise(subcontractors?.length, t('subcontractor:singular'))}
      </Flexbox>
    </Tooltip>
  )
}
